import React, { Component } from 'react'
import { auth, database, onAuthStateChanged, getRedirectResult, ref, get, update } from './firebase.js'
import AuthUserContext from './AuthUserContext.jsx'
import Auth from './components/modules/Auth.jsx'
import Loading from './components/commons/Loading.jsx'

const withAuthentication = (Comp) => {
  class WithAuthentication extends Component {
    constructor (props) {
      super(props)
      this.state = {
        authUser: null,
        loaded: false,
        error: null
      }
      this.modifyUser = this.modifyUser.bind(this)
    }
    componentDidMount () {
      onAuthStateChanged(auth, (authUser) => {
        if (authUser) {
          const userRef = ref(database, `usuarios/index/${authUser.uid}`)
          get(userRef)
            .then((snap) => {
              const user = {
                id: snap.key,
                name: snap.val().name,
                email: snap.val().email,
                photo: snap.val().photo,
                provider: snap.val().provider
              }
              this.setState({
                authUser: user,
                loaded: true
              })
            })
            .catch((err) => {
              console.error(err)
            })
        } else {
          this.setState({
            authUser: null,
            loaded: true
          })
        }
      })
      getRedirectResult(auth)
        .then((res) => {
          if (res && res.user) {
            const dbRef = ref(database, 'usuarios/index')
            const user = res.user.providerData[0]
            const userId = res.user.uid
            if (res.additionalUserInfo.isNewUser) {
              return update(dbRef, {
                [userId]: {
                  name: user.displayName,
                  email: user.email,
                  photo: user.photoURL,
                  provider: user.providerId
                }
              })
            } else {
              const userRef = ref(database, `usuarios/index/${userId}`)
              return update(userRef, { photo: user.photoURL })
            }
          }
        })
        .catch((err) => {
          console.error(err)
          this.setState({
            error: err.code + ' ' + err.message
          })
        })
    }
    modifyUser (name, photo) {
      const user = {
        id: this.state.authUser.id,
        name: name || this.state.authUser.name,
        email: this.state.authUser.email,
        photo: photo || this.state.authUser.photo,
        provider: this.state.authUser.provider
      }
      this.setState({
        authUser: user
      })
    }
    render () {
      if (this.state.authUser && this.state.loaded) {
        return (
          <AuthUserContext.Provider value={{ user: this.state.authUser, modifyUser: this.modifyUser }}>
            <Comp />
          </AuthUserContext.Provider>
        )
      } else if (!this.state.authUser && this.state.loaded) {
        return (
          <div className='app'>
            <Auth />
            {this.state.error && <div>{this.state.error}</div>}
          </div>
        )
      } else {
        return (
          <div className='app'>
            <div className='app__loading'>
              <Loading />
            </div>
          </div>
        )
      }
    }
  }
  return WithAuthentication
}

export default withAuthentication
